import { css } from 'styled-components';

export const components = css`
    --button-primary-default-text-color: var(--color-text-contrast);
    --button-primary-default-background-color: var(--color-primary);
    --button-primary-default-border: 2px solid transparent;
    --button-primary-hover-text-color: var(--color-primary);
    --button-primary-hover-background-color: var(--color-state-primary);
    --button-primary-hover-border: 2px solid transparent;
    --button-primary-active-text-color: var(--color-primary);
    --button-primary-active-background-color: var(--color-state-secondary);
    --button-primary-active-border: 2px solid transparent;
    --button-primary-disabled-text-color: var(--color-text-tertiary);
    --button-primary-disabled-background-color: var(--color-state-tertiary);
    --button-primary-disabled-border: 2px solid transparent;

    --button-secondary-default-text-color: var(--color-primary);
    --button-secondary-default-background-color: transparent;
    --button-secondary-default-border: 2px solid var(--color-primary);
    --button-secondary-hover-text-color: var(--color-primary);
    --button-secondary-hover-background-color: var(--color-state-primary);
    --button-secondary-hover-border: 2px solid var(--color-primary);
    --button-secondary-active-text-color: var(--color-primary);
    --button-secondary-active-background-color: var(--color-state-secondary);
    --button-secondary-active-border: 2px solid var(--color-primary);
    --button-secondary-disabled-text-color: var(--color-text-tertiary);
    --button-secondary-disabled-background-color: var(--color-state-tertiary);
    --button-secondary-disabled-border: 2px solid var(--color-state-tertiary);

    --button-tertiary-default-text-color: var(--color-primary);
    --button-tertiary-default-background-color: transparent;
    --button-tertiary-default-border: 2px solid transparent;
    --button-tertiary-hover-text-color: var(--color-primary);
    --button-tertiary-hover-background-color: var(--color-state-primary);
    --button-tertiary-hover-border: 2px solid transparent;
    --button-tertiary-active-text-color: var(--color-primary);
    --button-tertiary-active-background-color: var(--color-state-secondary);
    --button-tertiary-active-border: 2px solid transparent;
    --button-tertiary-disabled-text-color: var(--color-text-tertiary);
    --button-tertiary-disabled-background-color: transparent;
    --button-tertiary-disabled-border: 2px solid transparent;

    --button-navigation-default-text-color: var(--color-primary);
    --button-navigation-default-background-color: var(--color-white);
    --button-navigation-default-border: 2px solid transparent;
    --button-navigation-hover-text-color: var(--color-primary);
    --button-navigation-hover-background-color: var(--color-state-primary);
    --button-navigation-hover-border: 2px solid transparent;
    --button-navigation-active-text-color: var(--color-primary);
    --button-navigation-active-background-color: var(--color-state-secondary);
    --button-navigation-active-border: 2px solid transparent;
    --button-navigation-disabled-text-color: var(--color-text-tertiary);
    --button-navigation-disabled-background-color: var(--color-state-tertiary);
    --button-navigation-disabled-border: 2px solid transparent;

    --button-ghost-default-text-color: var(--color-primary);
    --button-ghost-default-background-color: var(--color-white);
    --button-ghost-default-border: 2px solid transparent;
    --button-ghost-hover-text-color: var(--color-primary);
    --button-ghost-hover-background-color: #ffffffdf;
    --button-ghost-hover-border: 2px solid transparent;
    --button-ghost-active-text-color: var(--color-primary);
    --button-ghost-active-background-color: #ffffffaf;
    --button-ghost-active-border: 2px solid transparent;
    --button-ghost-disabled-text-color: var(--color-text-tertiary);
    --button-ghost-disabled-background-color: var(--color-state-tertiary);
    --button-ghost-disabled-border: 2px solid transparent;
`;
